<template>
  <div class="modal-mask" v-if="visible">
    <div class="modal-wrapper">
      <div class="modal-container">
        <h3 class="modal-title">
          {{ title }}
        </h3>
        <div>
          <div class="inline-box">
            <!-- 单选框区域 -->
            <el-checkbox-group v-model="checkedList" @change="handleChange" class="select">
              <el-checkbox label="balance" :disabled="available_predeposit <= 0">{{ $t('Balance') }} ${{ available_predeposit }}</el-checkbox>
              <el-checkbox label="gift" :disabled="gift_balance <= 0">{{ $t('Gift Balance') }} ${{ gift_balance }}</el-checkbox>
            </el-checkbox-group>
          </div>
        </div>
        <div class="inline-box">
          <div class="modal-number">
            <van-stepper v-model="number" input-width="42px" button-size="22px"/>
            <span class="all-btn" @click="onAll">{{ this.$t('All') }}</span>
          </div>
        </div>
      </div>
      <!-- 按钮区 -->
      <div class="modal-footer">
        <button @click="onCancel">{{ cancelText }}</button>
        <button @click="onConfirm" style="border-left: .5px solid #f5f4f4;color:#ee0a24;">{{ confirmText }}</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "BuyConfirm",
  props: {
    visible: Boolean,
    title: String,
    message: String,
    available_predeposit: {
      type: String,
      default: '0.00'
    },
    gift_balance: {
      type: String,
      default: '0.00'
    },
    confirmText: {
      type: String,
      default: 'confirm'
    },
    cancelText: {
      type: String,
      default: 'cancel'
    },
    max_slots: {
      type: Number,
      default: 1
    },
    slots_sold: {
      type: Number,
      default: 1
    },
  },
  data() {
    return {
      checkedList: [],
      number: 1
    };
  },
  watch: {
    visible(val) {
      if (val) {
        this.setDefaultMethod();
      }
    }
  },
  methods: {
    setDefaultMethod() {
      const pre = Number(this.available_predeposit);
      const credit = Number(this.gift_balance);

      if (pre > 0 && credit <= 0) {
        this.checkedList = ['balance'];
      } else if (credit > 0 && pre <= 0) {
        this.checkedList = ['gift'];
      } else {
        this.checkedList = ['balance'];
      }
    },
    onAll(){
      this.number = this.max_slots - this.slots_sold;
    },
    onConfirm() {
      this.$emit('confirm', this.checkedList[0], this.number);
    },
    onCancel() {
      this.$emit('cancel');
    },
    handleChange(val) {
      const pre = Number(this.available_predeposit);
      const credit = Number(this.gift_balance);

      const availableOptions = [];
      if (pre > 0) availableOptions.push('balance');
      if (credit > 0) availableOptions.push('gift');

      if (availableOptions.length === 1) {
        // 只有一个可选项时，强制保留它
        this.checkedList = [availableOptions[0]];
      } else if (val.length > 1) {
        // 限制为单选：保留最后一个
        this.checkedList = [val[val.length - 1]];
      } else {
        this.checkedList = val;
      }
    }
  }
};

</script>

<style scoped>
/* ::v-deep .el-checkbox {
  color: #ee0a24 !important;
} */
 .inline-box {
  display: inline-block;
  padding-left: 20px;
 }
.all-btn{
  margin-left: 10px;
  border-radius: 4px;
  border: 1px solid #409EFF;
  font-size: 12px;
  padding: 0px 10px;
  color: #409EFF;
}
.select {
  padding-left: 20px;
  margin-top: 10px;
  text-align: left;
}

.select label {
  display: block;
  margin-bottom: 10px;
}

.modal-mask {
  position: fixed;
  z-index: 999;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
}
.modal-wrapper{
  width: 90%;
  background: white;
  border-radius: 8px;
}

.modal-container {
  text-align: center;
  width: 90%;
  padding: 5%;
}

.modal-title {
  font-weight: 500;
  font-size: 16px;
  margin: 10px;
}
.modal-number{
  display: flex;
  margin-top: 20px;
  font-size: 14px;
  line-height: 24px;
}

.modal-footer {
  display: flex;
  justify-content: space-between;
  gap: 10px;
  border-top: .5px solid #f5f4f4;
}

.modal-footer button {
  flex: 1;
  border: none;
  background-color: unset;
  height: 48px;
  font-size: 16px;
}
</style>
